<template>
  <div class="d-flex flex-column flex-md-row">
    <v-sheet color="transparent" width="100%">
      <ProductCategorySelect />
    </v-sheet>
  </div>
</template>

<script>
import ProductCategorySelect from "./fields/ProductCategorySelect.vue";
import { productFilter } from "../../utils/productFilter";

const _data = {
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    ProductCategorySelect,
  },
  mixins: [productFilter],
};
</script>
